export default __webpack_public_path__ + "static/media/dog-1.c25f7543.png";